<ng-container *ngIf="{
    displayHeadSpecializations: displayHeadSpecializations$ | async,
    headSpecializationsExpandedMap: headSpecializationExpandedMap$ | async,
    specializationSelectedMap: specializationsSelectedMap$ | async,
    allSpecializationsMap: allSpecializationsMap$ | async,
    selectedSpecializationsDisplayTags: selectedSpecializationsDisplayTags$ | async,
    maxSpecializationReached: maxSpecializationsReached$ | async,
    systemConfigs: systemConfigs$ | async
} as data">
    <div>
        <h2 class="specialization-header-label" mat-dialog-title>{{'text.ChooseSpecializationSpecialty' | translate}}</h2>
    </div>




    <mat-dialog-content>
    <div class="top-container">

        <div class="categories-selection">
            <div class="query-container">
                <input class="query-container__input" (input)="onSearch($event.target.value)" type="text"
                    placeholder="({{ 'label.Search' | translate }})" />
            </div>
            <div class="categories-container">
                <div class="head-category" *ngFor="let head of data.displayHeadSpecializations">
                    <div style="display: flex; cursor: pointer;" (click)="onToggleExpandHeadSpecialization(head)">
                        <div style="padding-bottom: 0.2rem;">
                            <svg-icon src="/assets/icons/chevron-down.svg"
                                [svgStyle]="{ 'width.rem':0.81, 'stroke': 'black', 'transform': data.headSpecializationsExpandedMap[head.specializationId] ? 'none' : 'rotate(180deg)' }">
                            </svg-icon>
                        </div>
                        <div style="padding-left: 0.7rem;">{{head.name}}</div>
                    </div>

                    <div style="padding-top: 1.5rem; padding-left: 1.7rem;"
                        [ngStyle]="{'display': data.headSpecializationsExpandedMap[head.specializationId]  ? 'block' : 'none'}">
                        <div *ngFor="let specializationId of head.childSpecializationIds">
                            <mat-checkbox [disabled]="data.maxSpecializationReached && !data.specializationSelectedMap[specializationId]" (change)="onToggleSpecialization(specializationId, $event)"
                                [ngModel]="data.specializationSelectedMap[specializationId]"
                                [ngModelOptions]="{standalone: true}">{{data.allSpecializationsMap[specializationId].name}}
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="category-chips">
            <div class="chips-container">
                <div class="category-tag" *ngFor="let specialization of data.selectedSpecializationsDisplayTags">

                    <div (click)="onRemoveSpecialization(specialization.specializationId)" class="category-tag__item">

                        {{ specialization.name }}

                        <svg-icon src="/assets/icons/remove.svg" class="remove-icon"></svg-icon>

                    </div>

                </div>
            </div>
            <div class="warning-message">
                <div>{{ 'message.PositionMaxSpecializationsWarning' | translate: {max: data.systemConfigs.jobseeker.workExperienceMaxSpecializations} }}</div>
            </div>
        </div>
    </div>

    </mat-dialog-content>





    <mat-dialog-actions>
        <div class="buttons">
            <app-button [ngClass]="{'disabled': false}"
                (click)="onSave(data.selectedSpecializationsDisplayTags)" [text]="'label.Save' | translate"
                [type]="buttonType.coloured" [typeAttribute]="buttonAttributeType.submit" class="button-save"></app-button>
            <app-button [text]="'label.Cancel' | translate" [type]="buttonType.uncoloured" [typeAttribute]="buttonAttributeType.button" (click)="onCancel()">
            </app-button>
        </div>
    </mat-dialog-actions>

</ng-container>